export enum BookingFormTypes {
  BOOKING_FORM_SUCCESS = 'BOOKING_FORM_SUCCESS',
}
